
define('app/users/recover/recoverApp',[
	'jquery',
	'underscore',
	'backbone',
	'unknown/models/recoverModel',
	'unknown/views/recoverView'
], function($, _, Backbone, RecoverModel, RecoverView){
	var initialize = function(){
		var recoverModel = new RecoverModel();
		var recoverView = new RecoverView({recoverModel: recoverModel});
		recoverView.render();
	};
	
	return {
		initialize: initialize
	};
});